import styled from 'styled-components';

const Container = styled.div`
  width: 95%;
  max-width: 100%;
  margin: 0 auto;
`;

export default Container;
